var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsMfaStep2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 96,
    viewBox: "0 0 128 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-mfa-step2",
    transform: "translate(-185 -223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4054",
    "data-name": "Rectangle 4054",
    width: 128,
    height: 96,
    transform: "translate(185 223)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7665",
    "data-name": "Group 7665",
    transform: "translate(-983 -278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-mobile-comm",
    transform: "translate(1190.008 502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M81.845,53.378l-6.518-3.16a55.328,55.328,0,0,0,.3-46.482L82.19.67A62.743,62.743,0,0,1,81.845,53.378ZM63.979,11.893a35.873,35.873,0,0,1-.291,30.144l6.506,3.184a43.285,43.285,0,0,0,.357-36.372ZM57.382,14V88a6.379,6.379,0,0,1-6.09,6.621h-.823v-.189H38.618c0,.006-5.431.006-5.431.006H27.756c0-.006-11.851-.006-11.851-.006v.189h-.823A6.379,6.379,0,0,1,8.992,88V14a6.38,6.38,0,0,1,6.09-6.622H51.29A6.381,6.381,0,0,1,57.382,14Zm-41.146.622V83.569H28.028c0,.014,5.159-.006,5.159-.006l5.159.02c0-.014,11.792-.014,11.792-.014V14.622h-33.9ZM37.262,89a4.075,4.075,0,1,0-4.075,4.074A4.074,4.074,0,0,0,37.262,89Z",
    fill: "#aaafb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7664",
    "data-name": "Group 7664",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4039",
    "data-name": "Rectangle 4039",
    transform: "translate(1225 551)",
    fill: "#1c2226",
    stroke: "#e3e5e6",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 30,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 46.5,
    height: 29.5,
    rx: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14932",
    "data-name": "Path 14932",
    d: "M-7393.5-3813h36.186",
    transform: "translate(8624.465 4384.767)",
    fill: "none",
    stroke: "#e3e5e6",
    strokeLinecap: "round",
    strokeWidth: 5,
    strokeDasharray: "0 7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kone_logo",
    transform: "translate(1243 562.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10845",
    "data-name": "Path 10845",
    d: "M1.5,29.4H3.94V24H1.5Zm5.364,0H9.3V24H6.864Zm-2.687,0h2.44V24H4.176ZM9.54,24v5.4h2.44V24Z",
    transform: "translate(-1.5 -28)",
    fill: "#0071b9"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMfaStep2);
export default __webpack_public_path__ + "static/media/icons-mfa-step2.411c939c.svg";
export { ForwardRef as ReactComponent };